import './App.css';
import Summary from './Pages/Summary';
import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Test from './Pages/Test';
import Documents from './Pages/Documents';
import PlantList from './Pages/PlantList';
import Contact from './Pages/Contact';

function App() {
  return (
    <Routes>
      <Route path="/" element={ <Home /> }/>
      <Route path="/summary" element={ <Summary /> }/>
      <Route path='/test' element={ <Test /> }/>
      <Route path='/documents' element={ <Documents /> }/>
      <Route path='/plantlist' element={ <PlantList /> }/>
      <Route path='/contact' element={ <Contact /> }/>
    </Routes>
  );
}

export default App;
